import Toast from "../../../Components/Cards/Toast";

const emptyList = [];

const normalizeTradeNotification = (notification) => {
  if (!notification) return notification;

  if (notification.type === "account_violation") {
    return {
      ...notification,
      persistent: true,
      showProgress: false,
    };
  }

  return notification;
};

export default function TradeNotifications({ notifications, onDismiss }) {
  const list = Array.isArray(notifications) ? notifications : emptyList;

  return (
    <Toast
      notifications={list.map(normalizeTradeNotification)}
      onDismiss={onDismiss}
      closeLabel="بستن"
    />
  );
}
